import { useEffect } from "react";
import { ResetStyle } from "../services/StyleService";

const useResetStyleHook = () => {
    useEffect(() => {        
        ResetStyle();
      }, []);
}

export default useResetStyleHook;